import type { CapabilityBinding } from '../../core/types';

/** AppInstance 能力绑定（应用镜像/多组存储仍为 pages 专有 UI，storage 模块无 L1 binding） */
export const APP_INSTANCE_CAPABILITIES = [
  {
    key: 'base-info',
    pathPrefix: '',
    options: {
      nameField: 'alias',
      nameMaxLength: 64,
      descriptionMaxLength: false,
      descriptionRows: 8,
    },
  },
  {
    key: 'runtime-config',
    pathPrefix: '',
  },
  {
    key: 'maas-system-config',
    pathPrefix: '',
  },
  {
    key: 'service',
    pathPrefix: '',
    options: { valueFormat: 'json-string' },
  },
  {
    key: 'env-vars',
    pathPrefix: '',
    options: { useCard: false, listSegment: 'commonEnv' },
  },
  {
    key: 'maas-node-groups',
    pathPrefix: '',
  },
  {
    key: 'health-check',
    pathPrefix: '',
  },
] as const satisfies readonly CapabilityBinding[];
